module.exports = __webpack_public_path__ + "img/figure-24.2df0b966.png";